/** Load optional components on initial markup and subsequent section inserts. */
const configuration = document.getElementById('HenryFeatureModules');
const pending = new Map(JSON.parse(configuration?.textContent || '[]').map((entry) => [entry.selector, entry.url]));
const loading = new Set();
const mobile = matchMedia('(max-width: 749px)');
const mobileHomepage = Boolean(document.querySelector('#MainContent[data-template="index"]')) && !window.Shopify?.designMode;
const deferredScopes = new Set();
const warmedScopes = new WeakSet();
const viewport = mobileHomepage && 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
  for (const entry of entries) {
    if (entry.isIntersecting) warm(entry.target);
  }
}, { rootMargin: '400px 0px' }) : null;

/** Hotspot controls stay ready; their form/variant graph can wait on mobile. */
function ready(element) {
  const scope = element.closest('.section-product-hotspots');
  if (!mobile.matches || !viewport || !scope || warmedScopes.has(scope)) return true;
  if (!deferredScopes.has(scope)) {
    deferredScopes.add(scope);
    viewport.observe(scope);
  }
  return false;
}

function warm(scope) {
  warmedScopes.add(scope);
  deferredScopes.delete(scope);
  viewport?.unobserve(scope);
  inspect(scope);
}

function onInteraction(event) {
  const scope = event.target instanceof Element && event.target.closest('.section-product-hotspots');
  if (scope) warm(scope);
}

function onBreakpointChange() {
  if (!mobile.matches) {
    for (const scope of deferredScopes) warm(scope);
  }
}

function stop() {
  observer.disconnect();
  viewport?.disconnect();
  deferredScopes.clear();
  document.removeEventListener('pointerdown', onInteraction, true);
  document.removeEventListener('focusin', onInteraction, true);
  mobile.removeEventListener('change', onBreakpointChange);
}

function inspect(root) {
  if (!(root instanceof Element || root instanceof Document)) return;
  for (const [selector, url] of pending) {
    if (loading.has(selector)) continue;
    const matches = [...root.querySelectorAll(selector)];
    if (root instanceof Element && root.matches(selector)) matches.unshift(root);
    if (!matches.some(ready)) continue;
    loading.add(selector);
    import(url).then(() => {
      pending.delete(selector);
      if (!pending.size) stop();
    }).catch((error) => {
      // Permit another section insertion to retry a failed network request.
      console.warn('Theme component could not be loaded:', selector, error);
    }).finally(() => loading.delete(selector));
  }
}

const observer = new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) inspect(node);
  }
  for (const scope of deferredScopes) {
    if (!scope.isConnected) {
      viewport?.unobserve(scope);
      deferredScopes.delete(scope);
    }
  }
});
observer.observe(document.body, { childList: true, subtree: true });
if (viewport) {
  document.addEventListener('pointerdown', onInteraction, { capture: true, passive: true });
  document.addEventListener('focusin', onInteraction, true);
  mobile.addEventListener('change', onBreakpointChange);
}
inspect(document);
